<mat-card>
  <mat-card-header>
    <div class="flex justify-between" style="width: 100%;">
      <div class="text-lg self-center">ประวัติเอกสาร มส.13 </div>
      <div>
        <button mat-icon-button class="close-button" [mat-dialog-close]>
          <i class="ti ti-x text-white"></i>
        </button>
      </div>
    </div>
  </mat-card-header>
  <mat-dialog-content class="flex flex-col mat-typography" style="gap: 15px;">
    <div class="flex flex-row justify-center gap-3">
      <div class="mat-elevation-z8 w100">
        <table mat-table matSort [dataSource]="dataSource" (matSortChange)="announceSortChange($event)">
          <ng-container matColumnDef="index">
            <th mat-header-cell mat-sort-header *matHeaderCellDef style="justify-content: center;">ลำดับ</th>
            <td mat-cell *matCellDef="let element; let i = index" style="justify-content: center;"> {{ i + 1 }} </td>
          </ng-container>

          <ng-container matColumnDef="logDate">
            <th mat-header-cell mat-sort-header *matHeaderCellDef style="justify-content: center;">วันที่เกิดรายการ
            </th>
            <td mat-cell *matCellDef="let element" style="justify-content: center;"> {{element.logDate | thaidate}} {{element.logDate | date:'HH:mm:ss'}}  </td>
          </ng-container>

          <ng-container matColumnDef="logDescription">
            <th mat-header-cell mat-sort-header *matHeaderCellDef style="justify-content: center;">รายละเอียดรายการ
            </th>
            <td mat-cell *matCellDef="let element" style="justify-content: center;"> {{element.actionDescription}} </td>
          </ng-container>

          <ng-container matColumnDef="logBy">
            <th mat-header-cell mat-sort-header *matHeaderCellDef style="justify-content: center;">ผู้ทำรายการ
            </th>
            <td mat-cell *matCellDef="let element" style="justify-content: center;"> {{element.logBy}} </td>
          </ng-container>

          <ng-container matColumnDef="action" style="text-align: left; min-width: 170px;">
            <th mat-header-cell *matHeaderCellDef style="text-align: left; min-width: 170px;"> รายละเอียด </th>
            <td mat-cell *matCellDef="let element;let i = index" style="text-align: left;min-width: 170px;">
              <div class="flex">
                <div>
                  <button mat-icon-button matTooltip="ดูรายละเอียด" matTooltipPosition="above"
                    (click)="openLog(element)">
                    <i class="ti ti-list-search"></i>
                  </button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons
          aria-label="Select page of periodic elements">
        </mat-paginator>
      </div>
    </div>
  </mat-dialog-content>
</mat-card>